import { Record } from 'immutable';

export const SesionVerify = new Record({
    isPending: false,
    success: true,
    error: 0,
    isNew: true,
});